import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(3 2)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M5.75 2H12.25V0H13.75V2H16C17.1046 2 18 2.89543 18 4V18C18 19.0357 17.2128 19.887 16.2041 19.9893L16 20H2L1.7959 19.9893C0.854346 19.8938 0.1062 19.1457 0.0107422 18.2041L0 18V4C0 2.89543 0.895431 2 2 2H4.25V0H5.75V2ZM1.5 18C1.5 18.2761 1.72386 18.5 2 18.5H16C16.2761 18.5 16.5 18.2761 16.5 18V8.75H1.5V18ZM5 14.5C5.55228 14.5 6 14.9477 6 15.5C6 16.0523 5.55228 16.5 5 16.5C4.44772 16.5 4 16.0523 4 15.5C4 14.9477 4.44772 14.5 5 14.5ZM9 14.5C9.55229 14.5 10 14.9477 10 15.5C10 16.0523 9.55229 16.5 9 16.5C8.44771 16.5 8 16.0523 8 15.5C8 14.9477 8.44771 14.5 9 14.5ZM13 14.5C13.5523 14.5 14 14.9477 14 15.5C14 16.0523 13.5523 16.5 13 16.5C12.4477 16.5 12 16.0523 12 15.5C12 14.9477 12.4477 14.5 13 14.5ZM5 10.5C5.55228 10.5 6 10.9477 6 11.5C6 12.0523 5.55228 12.5 5 12.5C4.44772 12.5 4 12.0523 4 11.5C4 10.9477 4.44772 10.5 5 10.5ZM9 10.5C9.55229 10.5 10 10.9477 10 11.5C10 12.0523 9.55229 12.5 9 12.5C8.44771 12.5 8 12.0523 8 11.5C8 10.9477 8.44771 10.5 9 10.5ZM13 10.5C13.5523 10.5 14 10.9477 14 11.5C14 12.0523 13.5523 12.5 13 12.5C12.4477 12.5 12 12.0523 12 11.5C12 10.9477 12.4477 10.5 13 10.5ZM2 3.5C1.72386 3.5 1.5 3.72386 1.5 4V7.25H16.5V4C16.5 3.72386 16.2761 3.5 16 3.5H13.75V5.5H12.25V3.5H5.75V5.5H4.25V3.5H2Z",
			fill: "currentColor"
		})
	})
});
export default SvgCalendar;
